import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ASYNC_CREATE_EVENT, ASYNC_EDIT_EVENT } from 'store';
import { useTranslation } from 'react-i18next';
import DatePicker, { registerLocale } from 'react-datepicker';
import History from 'components/History';
import { Form, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import Currency, { currencyReverse } from 'helpers/Currency';
import { api } from 'services';
import FileUploadMultiple from 'components/FileUploadMultiple';
import arrayAppend from 'helpers/array-append';
import { formatDate, parseDate } from 'helpers/date';
import { DashboardOutlined } from '@material-ui/icons';
import Can from 'components/Can';

import BR from 'date-fns/locale/pt-BR';

import EventsFormCompanies from 'components/Events/Form/Companies';
import EventsFormExpectedItems from 'components/Events/Form/ExpectedItems';
import EventsFormExpenseDescriptions from 'components/Events/Form/ExpenseDescriptions';

import Flow from 'components/Flow';

registerLocale('pt-BR', BR);

const EventsForm = ({
  createOrEditEvent,
  match: {
    params: { id },
  },
}) => {
  const [name, setName] = useState('');
  const [event, setEvent] = useState('');
  const [description, setDescription] = useState('');
  const [realStartDate, setRealStartDate] = useState('');
  const [realEndDate, setRealEndDate] = useState('');
  const [budgetedAmount, setBudgetedAmount] = useState('');
  const [files, setFiles] = useState([]);
  const [filesComments, setFilesComments] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]);
  const [actions, setActions] = useState([]);

  const [events, setEvents] = useState([]);

  const [expectedItems, setExpectedItems] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [expenseDescriptions, setExpenseDescriptions] = useState([]);

  const [currentStatus, setCurrentStatus] = useState(null);
  const [toSteps, setToSteps] = useState([]);
  const [status, setStatus] = useState('');

  const [concluir, setConcluir] = useState(false);
  const [messageAlert, setMessageAlert] = useState('');

  useEffect(() => {
    api.get(`event-actions/${id}`).then(({ data }) => {
      setActions(data);
      var concluir = true;
      data.forEach(a => {
        if (![17, 18].includes(a.status_id)) {
          concluir = false;
        }
      })
      setConcluir(concluir);
      getflowSteps()
    });
  }, []);

  useEffect(() => {
    // api.get(`flows/${4}/status`)
    //   .then(({ data }) => {
    //     if (data.steps[0]) {
    //       if (!!data.steps[0].to_steps)
    //         setToSteps(filter_event_id(data.steps[0].to_steps));
    //     }
    //   })
    getflowSteps()
  }, [currentStatus, concluir, id]);

  const getflowSteps = () => {
    api.get(`flows/${4}/status`)
      .then(({ data }) => {
        if (data.steps[0]) {
          if (!!data.steps[0].to_steps)
            setToSteps(filter_event_id(data.steps[0].to_steps));
        }
      })
  }

  const filter_event_id = (toSteps) => {
    toSteps = toSteps.filter(step => {
      if (step.id === 18 && !id)
        return false;
      else if (step.id === 18 && !concluir)
        return false
      return true;
    }).map((step) => {
      if (step.id === 1 && id)
        return { id: 1, name: 'draft', color: '#a9a5a5' };
      else return step;
    });
    return toSteps;
  };

  useEffect(() => {
    api
      .get('task-groups/list-for-event')
      .then(({ data }) => setEvents(data[0].tasks));

    if (id) {
      api.get(`events/${id}`)
      .then(({ data }) => {
        setConcluir(data.actions_count[0] == data.actions_count[1])
        setName(data.name);
        setEvent(data.task_id);
        setDescription(data.description);
        setRealStartDate(new Date(parseDate(data.start_date)));
        setRealEndDate(new Date(parseDate(data.end_date)));
        setBudgetedAmount(data.budgeted_amount);
        setExistingFiles(data.files);
        setCurrentStatus(data.status_id);
        setExpectedItems(data.items);
        setExpenseDescriptions(
          data.event_expense_descriptions.map((description) => ({
            ...description,
            ...{
              due_date: description.due_date ? new Date(parseDate(description.due_date)) : "",
              issuance_date: description.issuance_date ? new Date(parseDate(description.issuance_date)) : "",
              billet_due_date: description.billet_due_date ? new Date(parseDate(description.billet_due_date)) : null,
              hidden: true,
            },
          }))
        );
        
      });
    }
  }, [id]);

  /*useEffect(() => {
    api.get(`event-actions/${id}`).then(({ data }) => setActions(data));
  }, []);*/

  const quotaValue = () => {
    let countFund = 0;
    let countExtra = 0;
    actions.map((action) => {
      action.all_values.map((fund) => {
        countFund += fund.actual_value * fund.exchange;
      });
      if (action.extra_materials !== null) {
        action.extra_materials.map((extra) => {
          countExtra = +extra.value;
        });
      }
    });
    countFund = countFund + countExtra;
    countFund = countFund.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
    return countFund;
  };

  const { t } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();

    if (id) formData.append('id', id);

    formData.append('name', name);
    formData.append('task_id', event);
    formData.append('description', description);
    formData.append('start_date', formatDate(realStartDate));
    formData.append('end_date', formatDate(realEndDate));
    formData.append('budgeted_amount', currencyReverse(budgetedAmount));
    formData.append('status_id', status);
    formData.append('message_alert', messageAlert);

    arrayAppend(formData, 'file', files);
    arrayAppend(formData, 'files_comments', filesComments);
    createOrEditEvent(formData);
  };

  const totalExpectedValues = expectedItems.reduce(
    (total, valor) => total + valor.expected_value,
    0
  );
  const totalRealValue = expenseDescriptions.reduce(
    (total, valor) => total + valor.value,
    0
  );

  return (
    <Form onSubmit={handleSubmit}>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">{ name ? `Evento - ${name}` : t('title:event register')}</h4>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:event name')}</Form.Label>
                  <Form.Control
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:event type')}</Form.Label>
                  <Form.Control
                    as="select"
                    value={event}
                    onChange={(e) => setEvent(e.target.value)}
                  >
                    <option disabled value="">
                      {t('label:select')}
                    </option>
                    {events.map((event, k) => (
                      <option key={k} value={event.id}>
                        {event.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:brief description')}</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows="4"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label className="mr-3">
                    {t('label:init real date')}
                  </Form.Label>
                  <DatePicker
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    locale="pt-BR"
                    selected={realStartDate}
                    onChange={(date) => setRealStartDate(date)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label className="mr-3">
                    {t('label:end expected date')}
                  </Form.Label>
                  <DatePicker
                    minDate={realStartDate}
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    locale="pt-BR"
                    selected={realEndDate}
                    onChange={(date) => setRealEndDate(date)}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label className="mr-3">
                    {t('label:budgeted amount')}
                  </Form.Label>
                  <Currency
                    value={budgetedAmount}
                    onChange={(e) => setBudgetedAmount(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label className="mr-3">
                    {t('label:expected expense')}
                  </Form.Label>
                  <Currency value={totalExpectedValues} disabled />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label className="mr-3">
                    {t('label:real spent')}
                  </Form.Label>
                  <Currency value={totalRealValue} disabled />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label className="mr-3">
                    {t('label:quota value')}
                  </Form.Label>
                  <Currency value={quotaValue()} disabled />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <FileUploadMultiple
                  files={files}
                  setFiles={(files) => setFiles(files)}
                  filesComments={filesComments}
                  setFilesComments={(filesComments) =>
                    setFilesComments(filesComments)
                  }
                  existingFiles={existingFiles}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        {!id ? (
          <Alert className="mt-2 mb-0" variant="info">
            {t('phrase:exact event information after confirmation')}
          </Alert>
        ) : (
            <>
              <Row className="mt-2">
                <Col>
                  <EventsFormExpectedItems
                    {...{ eventId: id, expectedItems, setExpectedItems }}
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col>
                  <EventsFormCompanies
                    {...{ eventId: id, companies, setCompanies }}
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col>
                  <EventsFormExpenseDescriptions
                    {...{
                      eventId: id,
                      expenseDescriptions,
                      setExpenseDescriptions,
                      expectedItems,
                      setExpectedItems,
                    }}
                  />
                </Col>
              </Row>
            </>
          )}
        <Row className="mt-3">
          <Col>
            {/* <Flow
              toSteps={toSteps}
              setStatus={setStatus}
              currentStatus={currentStatus}
              setMessageAlert={setMessageAlert}
            /> */}
            {currentStatus != 18 ? (<>
              {toSteps.map((toStep, k) => {      
                const buttonEl = () => (
                  <Button
                    size="md"
                    variant="primary-login"
                    key={k}
                    type="submit"
                    className="login-btn mr-2 mt-5"
                    onClick={() => {
                      setStatus(toStep.id);
                    }}
                  >
                    {t(`flow:${toStep.name}`)}
                  </Button>
                )

                return (<>
                  {toStep.id == 18 ? (
                    <Can do="finishEvent" on="App">
                      {buttonEl()}
                    </Can>
                  ) : buttonEl()}
                </>)
              })}
            </>) : (<></>)}
          </Col>
        </Row>
        <Row>
          <Col>
            <History histories={[]} />
          </Col>
        </Row>
      </Card.Body>
    </Form>
  );
};

const mapStateToProps = (state) => ({});

const mapDisptachToProps = (dispatch) => ({
  createOrEditEvent: (payload) => {
    if (payload.has('id')) dispatch({ type: ASYNC_EDIT_EVENT, payload });
    else dispatch({ type: ASYNC_CREATE_EVENT, payload });
  },
});

const reduxConnect = connect(mapStateToProps, mapDisptachToProps)(EventsForm);

export default MasterPage(reduxConnect);
